// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1EEGb","title":"ClientInsurance_title__1kpQI","itemText":"ClientInsurance_itemText__1tt6C"};